import IconButton from '../../Buttons/Icon/IconButton';
import IconLink from '../../Links/Icon/IconLink';
import Props from './typings';

const PinterestIcon = ({
  size = 16,
  title = 'Artfinder Pinterest',
  action,
  url = 'https://pinterest.com/artfinder/',
  style,
}: Props) => {
  return action ? (
    <IconButton
      icon="pinterest"
      onClick={action}
      title={title}
      style={{
        icon: {size: size, color: {default: style?.color.default, hover: style?.color.hover}},
      }}
      data-test-id="pinterest-icon"
    />
  ) : (
    <IconLink
      data-test-id="pinterest-icon"
      icon="pinterest"
      href={url}
      title={title}
      style={{
        size: size,
        color: {default: style?.color.default, hover: style?.color.hover},
      }}
      target="_blank"
      className="pinterest-icon"
      rel="nofollow"
    />
  );
};

export default PinterestIcon;
